import { useState } from "react";

import type { IBudgetKanbanFilters } from "../../../../models/budgetV2";
import { exportBudgetsV2 } from "../../../../api/fetchBudgetV2";

export const useBudgetExport = (filters: IBudgetKanbanFilters) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);

        try {
            const { errorMessage } = await exportBudgetsV2(filters);
            if (errorMessage) throw new Error(errorMessage);
        } catch (error) {
            console.error(`Erro ao exportar orçamentos: ${error}`);
        } finally {
            setIsExporting(false);
        }
    };

    return { isExporting, handleExport };
}